import { config } from "../config.js";
import { mission } from "./missions.js";

// スケール感(2026-10-30 オーナー案「敵やオブジェクトがどんどん増えて大きくなり、カメラが引いていく。自機は相対的に小さくなる」)。
// ステージが進むほど「自機と自機の武器の届く範囲」以外の世界がまるごと大きくなる(倍率 = world.scale)。
//   - 動ける範囲・敵が出てくる位置・敵の大きさ・速さ・弾の速さ・流れる速さ … 倍率を掛ける
//   - 自機の大きさ・当たり判定・サーベルや主砲の届く範囲 … そのまま(だから自機が相対的に小さくなる)
// 速さにも倍率を掛けるので、敵が届くまでの秒や弾を避ける余裕は、倍率が変わってもほぼ同じ。
// 描画(src/view/)は同じ倍率でカメラを引き、広角にする。値は config.stages の scale と config.scale。

// 前進した秒(progress) → 倍率。ステージが変わってから config.scale.easeSeconds かけて次の倍率へ移る
export function scaleAt(progress) {
  const list = mission().stages;
  let i = 0;
  for (let k = 0; k < list.length; k++) if (progress >= list[k].from) i = k;
  const to = list[i].scale || 1;
  if (i === 0) return to;
  const from = list[i - 1].scale || 1;
  const k = Math.min(1, (progress - list[i].from) / config.scale.easeSeconds);
  return from + (to - from) * k;
}

// 倍率を掛けた空間の広さ(config.field の代わりに使う)
export function fieldOf(world) {
  const f = config.field;
  const s = world.scale || 1;
  return {
    halfWidth: f.halfWidth * s,
    halfHeight: f.halfHeight * s,
    spawnFrontZ: f.spawnFrontZ * s,
    spawnSideX: f.spawnSideX * s,
    despawnBehindZ: f.despawnBehindZ * s,
    scrollSpeed: f.scrollSpeed * s,
  };
}

// 敵の当たり判定の半径(出たときの倍率 e.size で大きくなる)
export function radiusOf(e) {
  return config.enemies.types[e.type].radius * (e.size || 1);
}
